// extracted by mini-css-extract-plugin
export default {"cta":"EE-z","disabled":"FE-z"};